import React from 'react'
import {CircularProgress} from "@mui/material";
import useLoadPlaylist from "../../../playlists/utils/useLoadPlaylist";
import CoursePlaylistCard from "../../../courses/card/playlist/CoursePlaylistCard";

const StatisticsPlaylistSummary = ({playlistKey}) => {
    const {playlist, loading} = useLoadPlaylist(playlistKey)

    if (loading) {
        return <CircularProgress/>
    }

    return <CoursePlaylistCard playlist={playlist} showInfo={true}/>

}
export default StatisticsPlaylistSummary
